// extracted by mini-css-extract-plugin
export var banner = "_3k-0";
export var icon = "_3k-1";
export var message = "_3k-2";